module.exports = "pegasus_template/assets/themelp1/scratch/102.png";